import {apiHelper} from "../redux/apiHelper"
export const getCmsMentalHealthSection=async()=>{
    try{
       let res=await apiHelper('get','/api/admin/cms-mental-health-section/list');
       if(res){
         return res;
       }
    }catch(e){
     console.log(e);
    }
 }
 export const addCmsMentalHealthSection=async(data)=>{

    try{
        let res=await apiHelper('post',`/api/admin/cms-mental-health-section/create`,data);
        if(res){
          return res;
        }
     }catch(e){
        console.log(e);
     }
 }
 export const updateCmsMentalHealthSection=async(id,data)=>{
   try{
       let res=await apiHelper('post',`/api/admin/cms-mental-health-section/update/${id}`,data);
       if(res){
         return res;
       }
    }catch(e){
       console.log(e);
    }
}
export const getCmsMentalHealthSectionById=async(id)=>{
   try{
       let res=await apiHelper('get',`/api/admin/cms-mental-health-section/get/${id}`);
       if(res){
         return res;
       }
    }catch(e){
     console.log(e);
    }
}
 export const deleteCmsMentallHealthSectionById=async(id)=>{
    try{
        let res=await apiHelper('delete',`/api/admin/cms-mental-health-section/delete/${id}`);
        if(res){
          return res;
        }
     }catch(e){
      console.log(e);
     }
    
}